import React from 'react';
import styled from '@emotion/styled';

export const PlayIcon = () => {
    return (
        <IconWrapper>
            <IconBorder>
                <PlayButton />
            </IconBorder>
        </IconWrapper>
    );
}

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #E21B22;
    border-radius: 0px 0px 0px 24px;
    width: 52px;
    height: 52px;    
`
const IconBorder = styled.section`
    background: #E21B22;
    border-radius: 2px;
    border: 2px solid #fff;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const PlayButton = styled.section`
    border: 0;
    background: transparent;
    box-sizing: border-box;
    width: 0;
   // height: 74px;
    border-color: transparent transparent transparent #fff;
    transition: 100ms all ease;
    cursor: pointer;

    // play state
    border-style: solid;
    border-width: 7px 0 7px 12px;

    &.paused {
        border-style: double;
        border-width: 0px 0 0px 60px;
    }

    &:hover {
        border-color: transparent transparent transparent #fff;
    }
`